<template>
  <div class="w-full min-h-screen">
    <slot />
  </div>
</template>
